var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28.002,
    viewBox: "0 0 28 28.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "link",
    d: "M25.9,2.115a7.234,7.234,0,0,0-10.223,0L12.253,5.543a8.927,8.927,0,0,1,4.34.347q.378.128.739.288l1.2-1.2a3.189,3.189,0,0,1,4.51,4.51l-2.471,2.47-4.02,4.021A3.189,3.189,0,0,1,11.383,15a3.041,3.041,0,0,1-.12-.32l-2.991,3.01a7.426,7.426,0,0,0,3.814,2.9q.289.094.585.163a7.354,7.354,0,0,0,6.574-1.769c.056-.053,6.658-6.652,6.658-6.652a7.237,7.237,0,0,0,0-10.223Zm-14.461,20q-.378-.128-.739-.288L9.5,23.03a3.189,3.189,0,0,1-4.51-4.51L11.8,11.782a1.861,1.861,0,0,1,.492-.342,3.242,3.242,0,0,1,2.662-.1,3.208,3.208,0,0,1,1.844,2.048l.007.023,3.023-3.023c.08-.08-.875-1.1-.972-1.2a7.4,7.4,0,0,0-1.263-1,7.2,7.2,0,0,0-8.965.991L2.131,15.664A7.227,7.227,0,0,0,7.217,28a7.312,7.312,0,0,0,5.138-2.115l3.427-3.427a8.94,8.94,0,0,1-4.34-.347Z",
    transform: "translate(-0.017 0)",
    fill: "#90348a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon_link.44d0f2876af609cbb91ffbf2e0dbc04e.svg";
export { ForwardRef as ReactComponent };